import React from "react";
import ReactDOM from "react-dom";
import { App } from "./components/App/App";
import registerServiceWorker from "./workers/registerServiceWorker";

ReactDOM.render(<App />, document.getElementById("root"));
registerServiceWorker();
